import * as React from 'react';
import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';
import { COLORS } from '../../styles';
import { Bullet, ChevronRight } from '../../icons';

const LinkStyles = css`
  border: none;
  background: transparent;
  padding: 16px 25px;

  color: ${COLORS.black};
  text-decoration: none;
  text-align: left;
  align-items: center;
  display: flex;
  font-weight: normal;
  font-size: 19px;
  line-height: 23px;
  color: ${COLORS.neutral_600};

  svg {
    margin-right: 15px;
    color: ${COLORS.neutral_600};
  }
`;

const InternalLink = styled(NavLink)`
  ${LinkStyles};
`;

const ExternalLink = styled.a`
  ${LinkStyles};
`;

const IconsRightSide = styled.div`
  margin: 0 0 0 auto;
  align-items: center;
  svg {
    margin-right: 0;
  }
`;

interface MenuLinkProps {
  to: string;
  menuText: string;
  isExternal?: boolean;
  Icon?: any;
  notification?: boolean;
  extendedMenu?: boolean;
  onClick?: () => void;
}

const MenuLink = ({ to, isExternal, menuText, Icon, notification, extendedMenu, onClick }: MenuLinkProps) => {
  const getRightSide = () => (
    <IconsRightSide>
      {notification ? <Bullet size="24px" color={COLORS.critical_500} /> : null}
      {extendedMenu ? <ChevronRight size="24px" color={COLORS.neutral_600} /> : null}
    </IconsRightSide>
  );
  return (
    <li>
      {isExternal ? (
        <ExternalLink
          key={`ExternalLink_${to}`}
          href={to}
          role="menuitem"
          className="UserMenuLink"
          onClick={() => {
            if (onClick) {
              onClick();
            }
          }}>
          {Icon && <Icon size="24px" />}
          <span>{menuText}</span>
          {getRightSide()}
        </ExternalLink>
      ) : (
        <InternalLink
          key={`InternalLink_${to}`}
          to={to}
          role="menuitem"
          className="UserMenuLink"
          onClick={() => {
            if (onClick) {
              onClick();
            }
          }}>
          {Icon && <Icon size="24px" />}
          <span>{menuText}</span>
          {getRightSide()}
        </InternalLink>
      )}
    </li>
  );
};

export default MenuLink;
